const User = (props) => {
    return (
        <div className="user">
            <h1>User</h1>
            <h2>Name : {props.name}</h2>
            <h2>Contact : {props.contact}</h2>
            <h2>LeetCode : {props.leetcode}</h2>
        </div>
    )
}
export default User;